import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { Card } from '@material-ui/core';
import CollapsibleBox from 'components/global/mui4/CollapsibleBox';
import getServiceDisplayNames from './serviceDisplayNames';

const useStyles = makeStyles({
  link: {
    textDecoration: 'underline',
    fontWeight: 'bold',
    color: '#0073e6',
  },
  serviceCard: {
    width: '100%',
    minHeight: '50px',
    background: '#FAFAFA',
    boxShadow: 'none',
    fontWeight: '600',
    fontSize: '15px',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '30px',
    marginBottom: '10px',
    borderRadius: '10px',
  },
  serviceCardTitle: {
    margin: '0px',
    color: '#303333',
    fontSize: '15px',
    fontWeight: '600',
  },
});

const ServiceCard = ({ serviceName }) => {
  const classes = useStyles();

  return (
    <Card className={classes.serviceCard}>
      <span className={classes.serviceCardTitle}>{serviceName}</span>
    </Card>
  );
};

const ServiceGroup = ({ categoryName, services, intl }) => {
  const classes = useStyles();
  const serviceDisplayNames = getServiceDisplayNames(intl);

  const hasVisibleServices = Object.values(services).some(value => value);

  if (!hasVisibleServices) {
    return null;
  }

  return (
    <div>
      <CollapsibleBox title={categoryName}>
        <div style={{ marginBottom: '30px' }}>
          <p>
            <FormattedMessage
              defaultMessage="For more information on any of the available services, please consult our {link}."
              values={{
                link: (
                  <a
                    href="https://greenshieldhealthpractitioner.zendesk.com/hc/en-ca/articles/36489624233108-Health-services-available-to-GreenShield-clients"
                    target="_blank"
                    className={classes.link}
                  >
                    <FormattedMessage defaultMessage="Knowledge Base" />
                  </a>
                ),
              }}
            />
          </p>
        </div>
        {Object.entries(services).map(([key, value]) => {
          if (value) {
            return (
              <ServiceCard
                key={key}
                serviceName={serviceDisplayNames[key] || key}
              />
            );
          }
          return null;
        })}
      </CollapsibleBox>
    </div>
  );
};

ServiceCard.propTypes = {
  serviceName: PropTypes.node.isRequired,
};

ServiceGroup.propTypes = {
  categoryName: PropTypes.string.isRequired,
  services: PropTypes.objectOf(PropTypes.bool).isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

injectIntl(ServiceCard);
export default injectIntl(ServiceGroup);
